/**
  * Перевести дату в строку для отображения на экране - минуты:секунды:час.милисекунды день.месяц.год
  *
  * @param {Date} moment - дата и время
  * @returns {string}
  */
function timeToString(moment) {
    return  ('0'+moment.getHours()).slice(-2)+':'+
            ('0'+moment.getMinutes()).slice(-2)+':'+
            ('0'+moment.getSeconds()).slice(-2)+' '+
            ('0'+moment.getDate()).slice(-2)+'.'+
            ('0'+(moment.getMonth()+1)).slice(-2)+'.'+
            moment.getFullYear().toString();
}

/**
  * Перевести дату в строку для отображения на экране - день.месяц.год минуты:секунды:час.милисекунды
  *
  * @param {Date} moment - дата и время
  * @returns {string}
  */
 function dateToString(moment) {
    return  moment.getFullYear().toString()+'.'+
        ('0'+(moment.getMonth()+1)).slice(-2)+'.'+
        ('0'+moment.getDate()).slice(-2)+' '+
        ('0'+moment.getHours()).slice(-2)+':'+
        ('0'+moment.getMinutes()).slice(-2)+':'+
        ('0'+moment.getSeconds()).slice(-2)+'.'+
        ('00'+moment.getMilliseconds()).slice(-3);
}

/**
  * Перевести дату в строку для формирования имени файла - день,месяц,год,минуты,секунды,час,милисекунды
  *
  * @param {Date} moment - дата и время
  * @returns {string}
  */
function dateToFileString(moment) {
    return  moment.getFullYear().toString()+
            ('0'+(moment.getMonth()+1)).slice(-2)+
            ('0'+moment.getDate()).slice(-2)+
            ('0'+moment.getHours()).slice(-2)+
            ('0'+moment.getMinutes()).slice(-2)+
            ('0'+moment.getSeconds()).slice(-2)+
            ('00'+moment.getMilliseconds()).slice(-3);
}


/**
  * Пауза (на промисах)
  *
  * @param {number} milisecconds - задержка в милисекундах
  * @returns {Promise}
  */
function sleep (milisecconds) {
    return new Promise(resolve => setTimeout(resolve, milisecconds));
}

function roundTimeMinutes(moment, minutes) {
    const val = moment.getMinutes();
    moment.setMinutes(val - val % minutes);
    moment.setSeconds(0);
    moment.setMilliseconds(0);
    return moment;
}

function roundTimeToDay(moment) {
    moment.setHours(0);
    moment.setMinutes(0);
    moment.setSeconds(0);
    moment.setMilliseconds(0);
    return moment;
}

function incTimeSeconds(moment, seconds) {
    moment.setSeconds(moment.getSeconds() + seconds);
    return moment;
}

function incTimeMinutes(moment, minutes) {
    moment.setMinutes(moment.getMinutes() + minutes);
    return moment;
}

function incTimeDays(moment, days) {
    moment.setDate(moment.getDate() + days);
    return moment;
}


// экспортируемые функции
export default {
    timeToString,
    dateToString,
    dateToFileString,
    sleep,
    roundTimeMinutes,
    roundTimeToDay,
    incTimeSeconds,
    incTimeMinutes,
    incTimeDays,
};
